<script setup lang="ts">
import type { ResolvedSelfSellInModel } from '../../composables/useSelfSellIn';
import SectionContainer from '../SectionContainer.vue';
import SectionHeader from '../SectionHeader.vue';
import OrderGuidelineCard from './OrderGuidelineCard.vue';

interface Props {
  data: ResolvedSelfSellInModel['orderGuidelinesSection'];
}

defineProps<Props>();
</script>

<template>
  <SectionContainer :section-title="data.title">
    <SectionHeader :title="data.title" :description="data.description" />
    <div class="order-guidelines-cards-container">
      <OrderGuidelineCard
        v-for="card in data.cards"
        :key="card.title"
        :title="card.title"
        :description="card.description" />
    </div>
  </SectionContainer>
</template>

<style lang="scss" scoped>
.order-guidelines-cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(345px, 100%), 1fr));
  gap: 6px;
}
</style>
